import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {},
			adsensConfig: {},

			tvGenres: [],
			MovieGenres: [],
			selectedYear: null,
			selectedTVYear: null,
			selectedStream: null,

			domainConfig: {},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setTvGenres(state, genres) {
				state.tvGenres = genres
			},
			setMovieGenres(state, genres) {
				state.MovieGenres = genres
			},
			setSelectedYear(state, year) {
				state.selectedYear = year
			},
			setSelectedTVYear(state, year) {
				state.selectedTVYear = year
			},
			setSelectedStream(state, stream) {
				state.selectedStream = stream
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			tvGenres: (state) => state.tvGenres,
			MovieGenres: (state) => state.MovieGenres,
			selectedYear: (state) => state.selectedYear,
			selectedTVYear: (state) => state.selectedTVYear,
			selectedStream: (state) => state.selectedStream,
		},
	})
}
